/* react */
import { Dispatch, FC, memo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
/* services */
import { startLoginFacebook, startLoginGoogle } from '@store'
/* types */
import { ROLE_BUTTON_MAP, VARIANT_BUTTON_MAP } from '@types'
/* components */
import { Button } from '@components'
/* assets */
import { FacebookIcon, GoogleIcon } from '@assets'
/* styles */
import './index.scss'

const SocialMedia: FC<{ title: string }> = ({ title }) => {
    const dispatch: Dispatch<any> = useDispatch()
    const navigate = useNavigate()

    return (
        <div className="social">
            <span>{title}</span>

            <div>
                <Button
                    className="social-media"
                    role={ROLE_BUTTON_MAP.NONE}
                    variant={VARIANT_BUTTON_MAP.OUTLINE}
                    onClick={() => {
                        dispatch(startLoginGoogle(navigate))
                    }}
                >
                    <i>
                        <GoogleIcon />
                    </i>
                </Button>

                <Button
                    className="social-media"
                    role={ROLE_BUTTON_MAP.NONE}
                    variant={VARIANT_BUTTON_MAP.OUTLINE}
                    onClick={() => {
                        dispatch(startLoginFacebook(navigate))
                    }}
                >
                    <i>
                        <FacebookIcon />
                    </i>
                </Button>

                {/* <Button className="social-media" role={ROLE_BUTTON_MAP.NONE} variant={VARIANT_BUTTON_MAP.OUTLINE}>
                    <i>
                        <AppleIcon />
                    </i>
                </Button>

                <Button className="social-media" role={ROLE_BUTTON_MAP.NONE} variant={VARIANT_BUTTON_MAP.OUTLINE}>
                    <i>
                        <Web3Icon />
                    </i>
                </Button> */}
            </div>
        </div>
    )
}

export default memo(SocialMedia)
